import Decimal from 'decimal.js';

export const countDecimals = value => {
  if (isNaN(Number(value))) return 0;

  if (Math.floor(value) === value) return 0;

  if (Number(value) < 0) {
    return countDecimals(Math.abs(Number(value)));
  }

  const str = value.toString();

  if (str.includes('.') && !str.includes('-')) {
    return str.split('.')[1].length || 0;
  }

  return Number(str.split('-')[1]) || 0;
};

export const truncateValue = (value, decimalsPrecision) => {
  if (decimalsPrecision === null || decimalsPrecision === undefined) {
    return value;
  }

  let numberValue = Number(value);
  if (isNaN(numberValue) || !isFinite(numberValue)) return value;

  const decimal = new Decimal(numberValue); // Use Decimal for precision handling
  if (decimal.isZero()) return 0;
  const preciseValue = decimal.toPrecision(decimalsPrecision);

  if (preciseValue.includes('e')) {
    return preciseValue;
  }
  // Convert back to number to remove trailing zeros and return as string
  return Number(preciseValue).toString();
};
